module.exports = __webpack_public_path__ + "static/napa.7528a7ca.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/napa.png
// module id = 445
// module chunks = 168707334958949